import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ClpLoginResponse } from '@reef/login';
import { CoreState, selectClpConfig } from '../redux/core.reducer';
import { HttpConfigService, HttpService } from '@reef/core';
import { UtilService } from '../services/util/util.service';
import { ClpInitConfigExtended } from '../model/clpInitConfigExtended.model';
import { LocalesService } from '../services/locales/locales.service';
@Component({
  templateUrl: './login-from-saml-sso.component.html',
  standalone: false
})
export class LoginFromSamlSsoComponent {
  private readonly httpService = inject(HttpService);
  private readonly store = inject<Store<CoreState>>(Store);
  private readonly utilService = inject(UtilService);
  private readonly window = inject<Window>('Window' as any);
  private readonly localesService = inject(LocalesService);
  private readonly httpConfig = inject(HttpConfigService);

  clpConfig$: Observable<ClpInitConfigExtended | undefined>;
  isSSOEnable = true;

  constructor() {
    this.clpConfig$ = this.store.select(selectClpConfig);
    this.clpConfig$.subscribe((config) => {
      if (config?.nonce) {
        this.isSSOEnable = config.loginParameters.externalSsoEnabled;
        if (this.isSSOEnable) {
          this.resolveFarmLink();
        }
      }
    });
  }

  resolveFarmLink(): void {
    const currentUrl = new URL(this.window.location.href);
    const accessToken = currentUrl.searchParams.get('access_token') || '';
    const idToken = currentUrl.searchParams.get('id_token') || '';
    const nonce = currentUrl.searchParams.get('nonce') || '';
    const language = currentUrl.searchParams.get('LANGUAGE') || this.localesService.getLanguageCode();
    const parameters: ClpLoginResponse = {
      accessToken,
      idToken,
      nonce
    };

    this.httpConfig.initConfig({
      ...this.httpConfig.getConfig(),
      language
    });
    this.httpService.postApfPlus('newlogin', 'redirectBookingFarm', parameters).subscribe((res: any) => {
      const response = res.response.model;
      this.processResponseResolveFarmLink(response, parameters);
    });
  }

  processResponseResolveFarmLink(response: any, parameters: ClpLoginResponse): void {
    // Delete nonce in the Url
    const bfUrl = response?.url?.replace(/&nonce=[A-Za-z0-9]*/g, '');
    // Redirect to Booking Farm
    this.utilService.createForm(bfUrl, parameters, true);
  }

  goToHost(): void {
    this.window.location.href = `${this.window.location.protocol}//${this.window.location.hostname}`;
  }
}
